module.exports = __webpack_public_path__ + "static/media/vtm-5000-1955-1961.0f8798cc.png";